/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppCreateSocialUploadCompositionsDetailMutationRequest, WebAppCreateSocialUploadCompositionsDetailMutationResponse, WebAppCreateSocialUploadCompositionsDetailPathParams, WebAppCreateSocialUploadCompositionsDetail401, WebAppCreateSocialUploadCompositionsDetail403 } from "../models/WebAppCreateSocialUploadCompositionsDetail";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { webAppCreateSocialUploadCompositionsDetail } from "../axios/webAppCreateSocialUploadCompositionsDetail";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const webAppCreateSocialUploadCompositionsDetailMutationKey = () => [{ url: '/web-app/v1/compositions/:id/social-uploads' }] as const

export type WebAppCreateSocialUploadCompositionsDetailMutationKey = ReturnType<typeof webAppCreateSocialUploadCompositionsDetailMutationKey>

export function webAppCreateSocialUploadCompositionsDetailMutationOptions<TContext = unknown>(config: Partial<RequestConfig<WebAppCreateSocialUploadCompositionsDetailMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = webAppCreateSocialUploadCompositionsDetailMutationKey()
        return mutationOptions<WebAppCreateSocialUploadCompositionsDetailMutationResponse, ResponseErrorConfig<WebAppCreateSocialUploadCompositionsDetail401 | WebAppCreateSocialUploadCompositionsDetail403>, {id: WebAppCreateSocialUploadCompositionsDetailPathParams["id"], data: WebAppCreateSocialUploadCompositionsDetailMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return webAppCreateSocialUploadCompositionsDetail(id, data, config)
          },
        })

}

/**
 * @summary Start social upload for a video-editor edit (composition context)
 * {@link /web-app/v1/compositions/:id/social-uploads}
 */
export function useWebAppCreateSocialUploadCompositionsDetail<TContext>(options: 
{
  mutation?: UseMutationOptions<WebAppCreateSocialUploadCompositionsDetailMutationResponse, ResponseErrorConfig<WebAppCreateSocialUploadCompositionsDetail401 | WebAppCreateSocialUploadCompositionsDetail403>, {id: WebAppCreateSocialUploadCompositionsDetailPathParams["id"], data: WebAppCreateSocialUploadCompositionsDetailMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<WebAppCreateSocialUploadCompositionsDetailMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? webAppCreateSocialUploadCompositionsDetailMutationKey()

          const baseOptions = webAppCreateSocialUploadCompositionsDetailMutationOptions(config) as UseMutationOptions<WebAppCreateSocialUploadCompositionsDetailMutationResponse, ResponseErrorConfig<WebAppCreateSocialUploadCompositionsDetail401 | WebAppCreateSocialUploadCompositionsDetail403>, {id: WebAppCreateSocialUploadCompositionsDetailPathParams["id"], data: WebAppCreateSocialUploadCompositionsDetailMutationRequest}, TContext>
          

          return useMutation<WebAppCreateSocialUploadCompositionsDetailMutationResponse, ResponseErrorConfig<WebAppCreateSocialUploadCompositionsDetail401 | WebAppCreateSocialUploadCompositionsDetail403>, {id: WebAppCreateSocialUploadCompositionsDetailPathParams["id"], data: WebAppCreateSocialUploadCompositionsDetailMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<WebAppCreateSocialUploadCompositionsDetailMutationResponse, ResponseErrorConfig<WebAppCreateSocialUploadCompositionsDetail401 | WebAppCreateSocialUploadCompositionsDetail403>, {id: WebAppCreateSocialUploadCompositionsDetailPathParams["id"], data: WebAppCreateSocialUploadCompositionsDetailMutationRequest}, TContext>
      
}